import(/* webpackMode: "eager" */ "/opt/build/repo/app/team/page.tsx");
